var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('a-spin'):_vm._e(),(!_vm.isLoading && !_vm.imageSrc)?_c('a-avatar',{attrs:{"size":_vm.size ? _vm.size : 'default',"icon":"user"}}):_vm._e(),(!_vm.isLoading && _vm.imageSrc)?_c('a-avatar',{attrs:{"size":_vm.size ? _vm.size : 'default',"src":_vm.imageSrc}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }